import React from 'react';
import PropTypes from 'prop-types';
import { Container, LoadMoreButton as StyledLoadMoreButton } from './loadMoreButton.styles';

export const LoadMoreButton = ({ label, onClick }) => {
  return (
    <Container>
      <StyledLoadMoreButton label={label} onClick={onClick} />
    </Container>
  );
};

LoadMoreButton.defaultProps = {
  label: 'Load more',
};

LoadMoreButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
